const initialStatus = {
  status: false,
  ids: "",
};
export default initialStatus;
